import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import APIError from 'utils/errors/http/APIError';
import FetchError from 'utils/errors/http/FetchError';
import getApiEndpoint from 'utils/apiEndpoint';
import getAuthJWT from 'utils/getAuthJWT';
import { notAgreedToTermsStatus } from 'const';
import { loadUser } from 'redux/actions/user';
var dispatch;
var setUpDispatch = function setUpDispatch(dispatchParam) {
  dispatch = dispatchParam;
};
var fetchAPI = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var _extras$parseJson;
    var params,
      extras,
      headers,
      authJWT,
      parseJson,
      parameters,
      url,
      response,
      _data,
      _data2,
      data,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          extras = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          headers = params.headers ? params.headers : {};
          _context.t0 = extras.jwt;
          if (_context.t0) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return getAuthJWT();
        case 7:
          _context.t0 = _context.sent;
        case 8:
          authJWT = _context.t0;
          parseJson = (_extras$parseJson = extras.parseJson) !== null && _extras$parseJson !== void 0 ? _extras$parseJson : true;
          parameters = _objectSpread(_objectSpread({}, params), {}, {
            headers: _objectSpread(_objectSpread({}, headers), authJWT && {
              Authorization: "Bearer ".concat(authJWT)
            })
          });
          url = getApiEndpoint(extras.uiUrl) + path;
          _context.prev = 12;
          _context.next = 15;
          return fetch(url, parameters);
        case 15:
          response = _context.sent;
          _context.next = 21;
          break;
        case 18:
          _context.prev = 18;
          _context.t1 = _context["catch"](12);
          throw new FetchError(_context.t1);
        case 21:
          if (response.ok) {
            _context.next = 32;
            break;
          }
          _context.prev = 22;
          _context.next = 25;
          return response.json();
        case 25:
          data = _context.sent;
          _context.next = 30;
          break;
        case 28:
          _context.prev = 28;
          _context.t2 = _context["catch"](22);
        case 30:
          // If the user didn't agree to the terms of use,
          // Reload the user so that we trigger the TermsOfUseIntercept
          if (response.status === notAgreedToTermsStatus) {
            dispatch(loadUser());
          }

          // data.message & data.errors follow error formatting defined in:
          // HTTPError.v1.yaml
          throw new APIError(response.status, (_data = data) === null || _data === void 0 ? void 0 : _data.message, (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.errors);
        case 32:
          if (parseJson) {
            _context.next = 34;
            break;
          }
          return _context.abrupt("return", response);
        case 34:
          _context.next = 36;
          return response.json();
        case 36:
          return _context.abrupt("return", _context.sent);
        case 37:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[12, 18], [22, 28]]);
  }));
  return function fetchAPI(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default fetchAPI;
export { setUpDispatch };